export const REQUEST_ERROR = Symbol("REQUEST_ERROR");

export const SINGLE_API = Symbol("SINGLE_API");

export const UPDATE_STORE = Symbol("UPDATE_STORE");

export const UPDATE_STORE_MISSION = Symbol("UPDATE_STORE_MISSION");
